import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const MetricRow = ({ metric, ruleData }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const renderScore = (score) => {
    if (typeof score === 'number') {
      return (score * 100).toFixed(2) + '%';
    } else if (typeof score === 'string') {
      return score;
    } else if (typeof score === 'object') {
      return JSON.stringify(score);
    }
    return 'N/A';
  };

  return (
    <>
      <tr>
        <td>
          {ruleData.sub_rules && ruleData.sub_rules.length > 0 ? (
            <button onClick={() => setIsExpanded(!isExpanded)} className="flex items-center">
                {metric}
                {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
          ) : (
            metric
          )}
        </td>
        <td>{renderScore(ruleData.rule_score)}</td>
      </tr>
      {isExpanded && ruleData.sub_rules && ruleData.sub_rules.length > 0 && (
        <tr>
          <td colSpan="2">
            <table className="w-full">
              <thead>
                <tr>
                  <th>Failed</th>
                  {/* <th>Passed</th> */}
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {ruleData.sub_rules.map((subRule, index) => (
                  <tr key={index}>
                    <td>{subRule[0]}</td>
                    {/* <td>{subRule[1] ? 'Yes' : 'No'}</td> */}
                    <td>{subRule[2]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      )}
    </>
  );
};

const DisplayScores = ({scores}) => {
  const [showDetailedScores, setShowDetailedScores] = useState(false);
  console.log("Scores:", scores);
  return (
    <div className="schedule-scores">
      <div className="schedule-scores-header">
        <h2>Schedule Scores</h2>
        <button 
          className="toggle-scores-btn"
          onClick={() => setShowDetailedScores(!showDetailedScores)}
        >
          {showDetailedScores ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </button>
      </div>
      <div className="overall-score">
        Overall Score: {(scores['Overall Score'] * 100).toFixed(2)}%
      </div>
      <div className="overall-score">
        Time Taken: {scores['Time taken']}
      </div>
      <div className="overall-score">
        Rules Relaxed: {scores['Rules Relaxed'] ? 'True' : 'False'}
      </div>
      <div className="overall-score">
        Hard Rules Score: {(scores['Hard Rules Score'] * 100).toFixed(2)}%
      </div>
      {showDetailedScores && (
        <table className="w-full">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(scores).map(([metric, score]) => {
              if (metric !== 'Overall Score' && metric !== 'Time taken' && metric !== 'Coverage By Day' && metric !== 'rules' && metric !== 'Rules Relaxed' && metric !== 'Hard Rules Score') {
                return <MetricRow key={metric} metric={metric} ruleData={{ rule_score: score }} />;
              }
              return null;
            })}
            {scores.rules && Object.entries(scores.rules).map(([metric, ruleData]) => (
              <MetricRow key={metric} metric={metric} ruleData={ruleData} />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const ScheduleScores = ({ scheduleScores, scheduleGenerated }) => {
  return (
    <div className="schedule-scores-container">
      {scheduleGenerated && scheduleScores && <DisplayScores scores={scheduleScores} />}
    </div>
  );
};

export default ScheduleScores;